import { apiSlice } from '../../../../app/apiSlice';
import { TipoPublicacaoOficial, TipoPublicacaoOficialDTO, TipoPublicacaoOficialList } from '../../../../typesSite/tipoPublicacaoOficial/TipoPublicacaoOficial';
import configSiteUrls from '../../configs/configSiteUrls';

const endpointUrl = configSiteUrls.SITE_TIPO_PUBLICACAO_OFICIAL_EP;
const endpointUrlPublic = configSiteUrls.SITE_TIPO_PUBLICACAO_OFICIAL_PUBLIC_EP;

function getTipoPublicacaoOficiais({ search }: { search: string }) {
  return {
    url: `${endpointUrlPublic}/filter?search=${search}`,
    method: 'GET'
  };
}

function addTipoPublicacaoOficial(obj: TipoPublicacaoOficialDTO) {
  return {
    url: `${endpointUrl}/create`,
    method: 'POST',
    body: obj
  };
}

function deleteTipoPublicacaoOficial({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}
function getTipoPublicacaoOficial(id: string) {
  if (!id) {
    return {
      url: '',
      method: ''
    };
  } 

  return {
    url: `${endpointUrl}/${id}`,
    method: 'GET'
  };
}

function getTipoPublicacaoOficialByNome(nome: string) {
  if (!nome) {
    return {
      url: '',
      method: ''
    };
  } 

  return {
    url: `${endpointUrlPublic}/${nome}`,
    method: 'GET'
  };
}
/** */

export const TipoPublicacaoOficialApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getTipoPublicacaoOficiais: query<TipoPublicacaoOficialList[], { search: string }>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getTipoPublicacaoOficiais,
      providesTags: ['TipoPublicacaoOficial']
    }),

    getTipoPublicacaoOficial: query<TipoPublicacaoOficial, string>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getTipoPublicacaoOficial,
      providesTags: ['TipoPublicacaoOficial']
    }),
    getTipoPublicacaoOficialByNome: query<TipoPublicacaoOficial, string>({
      //query: (id) => `${endpointUrl}/ciencia/${id}`,
      query: getTipoPublicacaoOficialByNome,
      providesTags: ['TipoPublicacaoOficial']
    }),
    addTipoPublicacaoOficial: mutation<void, TipoPublicacaoOficial>({
      query: addTipoPublicacaoOficial,
      invalidatesTags: ['TipoPublicacaoOficial']
    }),
    deleteTipoPublicacaoOficial: mutation<void, { id: string }>({
      query: deleteTipoPublicacaoOficial,
      invalidatesTags: ['TipoPublicacaoOficial']
    })
  })
});
export const { useGetTipoPublicacaoOficiaisQuery, useGetTipoPublicacaoOficialQuery, useAddTipoPublicacaoOficialMutation, useDeleteTipoPublicacaoOficialMutation, useGetTipoPublicacaoOficialByNomeQuery } = TipoPublicacaoOficialApiSlice;
